<template>
    <dialogComponent name="ieAlert">
        <template v-slot="dialog">
            <div class="modal modal_tips modal_zccg login_modal_tips">
                <div class="fp_modal">
                    <div class="cell">
                        <div class="modal_cont" style="width:400px">
                            <div class="tit">
                                <h3>贴心提示</h3>
                            </div>
                            <div class="cont">
                                <div class="modal_tips_web center">
                                    <p style="padding:25px">为提供最佳的游戏体验，请使用平台建议的浏览器<br>Edge、Firefox、搜狗、Google Chrome！</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </dialogComponent>
</template>

<script>
export default {
    name: "IEAlert",
    methods: {
        showDialog() {
            let _ieAlertDialog = this.$dialog.get('ieAlert');
            _ieAlertDialog.show();
        },
    },
}
</script>